import { render, staticRenderFns } from "./PreFooterSection.vue?vue&type=template&id=e5980db6&scoped=true"
import script from "./PreFooterSection.vue?vue&type=script&lang=js"
export * from "./PreFooterSection.vue?vue&type=script&lang=js"
import style0 from "./PreFooterSection.vue?vue&type=style&index=0&id=e5980db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5980db6",
  null
  
)

export default component.exports